import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal from '@mui/material/Modal';

import Button from 'src/component/UI/Button';
import AcceptIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'src/i18n';

export default function ConfirmModal (props) {
  const { t } = useTranslation();

  const {
    handleConfirm,
    handleReject,
    handleClose,
    open,
    message,
    title,
    confirmPhrase,
    noCancelOption
  } = props;

  const [userConfirmInput, setUserConfirmInput] = useState('');

  const onHandleAccept = (values) => {
    setUserConfirmInput('');
    if (handleConfirm) {
      handleConfirm(values);
    }
  };

  const onHandleReject = (values) => {
    setUserConfirmInput('');
    if (handleReject) {
      handleReject(values);
    }
  };

  const onUserConfirmPhraseUpdated = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserConfirmInput(event.target.value);
  };

  return (
    <Modal
      data-testid='confirm-modal'
      open={open}
      onClose={handleClose}
      aria-labelledby='confirm-modal-title'
    >
      <div className='modal confirm-modal'>
        <h2 id='confirm-modal-title'>{title || t('modal.confirmation')}</h2>
        <p>{message || t('modal.areYouSure')}</p>
        {confirmPhrase ?
          <TextField id='confirmPhraseInput' name='confirmPhraseInput' label={t('modal.typeToConfirm', { phrase: confirmPhrase })}  type={'input'}
            onChange={onUserConfirmPhraseUpdated} value={userConfirmInput} InputLabelProps={{ shrink: false }} />
          : null
        }
        <div className='button-bar'>
          {noCancelOption ? null : <Button variant="contained" onClick={onHandleReject}>{t('common.cancel')}</Button>}
          <Button
            variant="contained"
            onClick={onHandleAccept}
            icon={<AcceptIcon style={{ fontSize: 14 }} />}
            disabled={confirmPhrase && userConfirmInput !== confirmPhrase}
            cta>
            {t('modal.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

ConfirmModal.propTypes = {
  handleConfirm: PropTypes.func.isRequired,
  handleReject: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  confirmPhrase: PropTypes.string,
  noCancelOption: PropTypes.bool
};

ConfirmModal.defaultProps = {
  noCancelOption: false
};
